import 'jquery';
import {plenigoLog} from './logger';

/**
 * @see https://docs.datatrans.ch/docs/secure-fields
 * @see https://docs.datatrans.ch/docs/testing-credentials
 *
 */

(function ($, SecureFields) {
  let form = $('form[data-datatrans-transaction]');

  if (!form.length || !SecureFields) {
    return;
  }

  let transactionId = form.data('datatrans-transaction'),
    cardNumberField = form.find('[data-field="cardNumber"]'),
    // cvvField = form.find('[data-field="cvv"]'),
    expiryField = form.find('[data-field="expiry"]'),
    brandField = form.find('[data-field="brand"]'),
    redirectUrlField = form.find('[data-field="redirectUrl"]'),
    transactionIdField = form.find('[data-field="transactionId"]'),
    submitButton = form.find(':submit'),
    errorUrl = form.data('error-url'),
    secureFields = new SecureFields(),
    complete = false,
    expiryMonth = '',
    expiryYear = '',
    // JSON:
    //'*': {
    //    border: '2px solid black',
    //    padding: '.65em .5em'
    //    backgroundColor: 'blue',  // background-color
    //    backgroundImage: 'none',  // background-image
    //    boxSizing: 'border-box',  // box-sizing
    //    WebkitBoxShadow: 'none',  // -webkit-box-shadow
    //    WebkitAppearance: 'none'  // -webkit-appearance
    //}
    styles = {
      '*': 'font-family: Helvetica, Arial;',
    };

  /**
   * Handling Events
   * @see https://docs.datatrans.ch/docs/secure-fields-events#section-browser-autofill
   */
  secureFields.on('change', function(data) {
    let event = data.event,
      el;

    if (!event.field) {
      return;
    }

    el = form.find('[data-field="' + event.field + '"]');

    if (event.type === 'autocomplete') {
      if (event.field === 'expiryMonth') {
        expiryMonth = event.value; // "12"
      }

      if (event.field === 'expiryYear') {
        expiryYear = event.value.slice(-2); // "2021" (note: take the last two digits for MM/YY)
      }
    }

    if (expiryMonth && expiryYear) {
      expiryField.val(`${expiryMonth}/${expiryYear}`);
    }

    if (!el.length) {
      return;
    }

    if (!event.type) {
      return;
    }

    if (event.type === 'focus') {
      el.addClass('filled');
      secureFields.setPlaceholder(event.field, el.data('placeholder'));
    }

    if (event.type === 'blur' && !el.data('filled')) {
      el.removeClass('filled');
      secureFields.setPlaceholder(event.field, '');
    }

    if (event.type === 'keyUp') {
      el.data('filled', true);
      el.removeClass('is-invalid');
      secureFields.setStyle('cardNumber.invalid','color: #000');
      secureFields.setStyle('cvv.invalid','color: #000');
    }
  });

  /**
   * @see https://docs.datatrans.ch/docs/secure-fields-events#error
   */
  secureFields.on('error', function(data) {
    if (errorUrl) {
      location.href = decodeURIComponent(errorUrl).replace('{msg}', data.error || 'unknown');
    }
    plenigoLog.error('Datatrans form error', data);
  });

  /**
   * @see https://docs.datatrans.ch/docs/secure-fields-events#ready
   *
   * Idea: in our styling we do not show placeholders on default
   */
  secureFields.on('ready', function() {
    // Placeholder for the card number field
    secureFields.setPlaceholder('cardNumber', '');
    // Placeholder for the card security number
    secureFields.setPlaceholder('cvv', '');

    secureFields.setStyle('cardNumber','width: ' + cardNumberField.width() + 'px');
  });

  /**
   * @see https://docs.datatrans.ch/docs/secure-fields-events#validate
   */
  secureFields.on('validate', function(event) {
    // Add a red border if a field is invalid
    if (!event.hasErrors) {
      return;
    }
    // enable submit button
    submitButton.removeClass('loading').prop('disabled', false);
    // style fields
    secureFields.setStyle('cardNumber.invalid','color: #eb0c0c');
    secureFields.setStyle('cvv.invalid','color: #eb0c0c');

    if (!event.fields) {
      return;
    }

    for (const field in event.fields) {
      const el = form.find('[data-field="' + field + '"]');
      if (!event.fields[field].valid) {
        el.addClass('is-invalid');
      }
    }

  });

  /**
   * @see https://docs.datatrans.ch/docs/secure-fields-events#success
   */
  secureFields.on('success', function(data) {
    console.log('success');
    console.log(data);

    if (data.transactionId) {
      transactionIdField.val(data.transactionId || '');
      if (data.cardInfo && data.cardInfo.brand) {
        brandField.val(data.cardInfo.brand || '');
      }

      if (data.redirect) {
        redirectUrlField.val(data.redirect);
      }

      complete = true;
      form.submit();
    }
  });

  /**
   * @see https://codepen.io/stoXmod/pen/bGePmdd
   */
  expiryField.on('keyup', function (event) {
    let code = event.keyCode,
      // inputChar = String.fromCharCode(event.keyCode),
      allowedKeys = [8];

    if (allowedKeys.indexOf(code) !== -1) {
      return;
    }

    event.target.value = event.target.value.replace(
      /^([1-9]\/|[2-9])$/g, '0$1/' // 3 > 03/
    ).replace(
      /^(0[1-9]|1[0-2])$/g, '$1/' // 11 > 11/
    ).replace(
      /^([0-1])([3-9])$/g, '0$1/$2' // 13 > 01/3
    ).replace(
      /^(0?[1-9]|1[0-2])([0-9]{2})$/g, '$1/$2' // 141 > 01/41
    ).replace(
      /^([0]+)\/|[0]+$/g, '0' // 0/ > 0 and 00 > 0
    ).replace(
      /[^\d/]|^[/]*$/g, '' // To allow only digits and `/`
    ).replace(
      /\/\//g, '/' // Prevent entering more than 1 `/`
    );
  });


  /**
   * @see https://docs.datatrans.ch/docs/secure-fields#initializing-our-javascript-library
   */
  secureFields.init(transactionId, {
    cardNumber: {
      placeholderElementId: 'cardNumberPlaceholder',
      // inputType: 'text',
      placeholder: '',
    },
    cvv:  {
      placeholderElementId: 'cvvPlaceholder',
      // inputType: 'tel',
      placeholder: '',
    },
  },{
    styles: styles,
    focus: 'cardNumber',
  });

  form.on('submit', function (event){
    let expires = expiryField.val().split('/');

    submitButton.addClass('loading').prop('disabled', true);

    if (!complete) {
      event.preventDefault();

      secureFields.submit({
        expm: parseInt(expires[0], 10), // ask for the expiry month in your form
        expy: parseInt(expires[1], 10), // ask for the expiry year in your form
      });

      return false;
    }
  });

}(jQuery, (window.SecureFields || null)));
